export default __webpack_public_path__ + "static/1290-61d2d3fba9f3aa06c61cee83655430c8.gif";